import { array, string, optional, object, enums, boolean } from 'superstruct';

const JourneyTabName = Object.freeze({
  Activities: 'activities',
  Progress: 'progress',
  History: 'history',
  Explore: 'explore',
});

const JourneyTabs = Object.values(JourneyTabName);

export const healthJourneyConfigSchema = object({
  tabs: optional(array(enums(JourneyTabs))),
  headerConfig: optional(
    object({
      backgroundImageSrc: optional(string()),
      disableBackgroundImage: optional(boolean()),
      enableHeaderSubTitle: optional(boolean()),
      backgroundColor: optional(string()),
      alignment: optional(enums(['start', 'center', 'end'])),
      backgroundImageHeight: optional(
        object({
          default: optional(string()),
          phone: optional(string()),
          tablet: optional(string()),
        }),
      ),
    }),
  ),
  historyBadgeColors: optional(
    object({
      challenge: optional(string()),
      'opt-in': optional(string()),
      reward: optional(string()),
    }),
  ),
  activityDetailsConfig: optional(
    object({
      enableFullPageBackground: optional(boolean()),
    }),
  ),
});
